import React, { useEffect, useRef } from 'react';
import get from 'lodash/get';
import InfiniteScroll from '../utils/infiniteScroll';

export function useLazyLoad({ node, loadMore, path }) {
  const infinityInstance = useRef(null);
  const element = get(node, ['current', ...path]);

  useEffect(() => {
    infinityInstance.current = new InfiniteScroll({
      element,
      type: 'lower',
      onLoad: loadMore,
      loadEdgeOffset: 50,
    });

    return () => {
      infinityInstance.current.unsubscribe();
    };
  }, [element]);

  useEffect(() => {
    if (infinityInstance.current) {
      infinityInstance.current.onLoad = loadMore;
    }
  }, [loadMore]);
}



// WEBPACK FOOTER //
// ./src/hocs/useLazyLoad.jsx